import React from 'react';

export const getFormErrorMessage = (errors: Record<string, any>, name: string) => {
  if (errors[name]) {
    return React.createElement('span', { className: 'error text-sm' }, errors[name].message);
  }
  return React.createElement('span', { className: 'error text-sm' }, '\u00A0');
}
